if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.fetchAndDisplay();
    }

    fetchAndDisplay() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const newContent = tempDiv.querySelector('product-recommendations');

          if (newContent && newContent.innerHTML.trim().length) {
            this.innerHTML = newContent.innerHTML;

            // Additional logic to handle specific cases
            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }

            if (tempDiv.querySelector('c')) {
              this.classList.add('product-recommendations--loaded');
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);
}
